import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import AnalysisPage from './AnalysisPage';
import TestRigPage from './TestRigPage';
import HistoryPage from './HistoryPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-slate-100">
        <nav className="bg-white shadow-sm mb-8">
          <div className="max-w-4xl mx-auto px-4 py-4 flex justify-between items-center">
            <Link to="/" className="font-bold text-xl text-blue-600">Auction.ai</Link>
            <div className="space-x-6">
              <Link to="/history" className="text-slate-600 hover:text-blue-600">History</Link>
              <Link to="/test-rig" className="text-slate-600 hover:text-blue-600">Test Rig</Link>
            </div>
          </div>
        </nav>

        <main className="container mx-auto px-4 pb-12">
          <Routes>
            <Route path="/" element={<AnalysisPage />} />
            <Route path="/test-rig" element={<TestRigPage />} />
            <Route path="/history" element={<HistoryPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
